import DuckImage from '../../images/games/35reveal/duck.png';
import GirlImage from '../../images/games/35reveal/girl.png';
import FaceImage from '../../images/games/35reveal/face.png';
import FireplaceImage from '../../images/games/35reveal/fireplace.png';
import TileImage from '../../images/games/35reveal/tile.png';
import SkylineImage from '../../images/games/35reveal/skyline.png';
import SidewaysImage from '../../images/games/35reveal/sideways.png';
import MountainImage from '../../images/games/35reveal/mountain.png';
import TreeImage from '../../images/games/35reveal/tree.png';
import ZebraImage from '../../images/games/35reveal/zebra.png';
import ElephantImage from '../../images/games/35reveal/elephant.png';
import BoatImage from '../../images/games/35reveal/boat.png';

var rNet = 1;
var ptStep = 1;

//$("#picContainer").click(function() {
//	$(revOrder[0]).fadeTo(1000, 0);
//	$("#choiceCont").css("opacity","1");
//	$("#click").css("opacity","0");
//	$("input").val("");
//});

var imageMapping = {
  'A': DuckImage,
  'B': GirlImage,
  'C': FaceImage,
  'D': FireplaceImage,
  'E': TileImage,
  'F': SkylineImage,
  'G': SidewaysImage,
  'H': MountainImage,
  'I': TreeImage,
  'J': ZebraImage,
  'K': ElephantImage,
  'L': BoatImage
}

function setImageDimensions(dimensions) {
  $('#picContainer').css('width', dimensions[0]);
  $('#picContainer').css('height', dimensions[1]);
};

function getImageDimensions(image_src, callback) {
  var image = new Image();
  image.src = image_src;
  image.onload = function() { callback(this.width, this.height); }
};

function setBoxes() {
  $('.picCorner').css('width', getImageDimensions[0] / 2);
  $('.picRow').css('height', getImageDimensions[1] / 2);
};

function changeGamePicture(letter) {
  $('#pickGameContainer').addClass('d-none');
  $('#gameContainer').removeClass('d-none');
  $('.btn-back').addClass('d-none');
  $('.btn-refresh').removeClass('d-none');
  $('#picContainer').css("background-image", 'url(' + imageMapping[letter] + ')');
  var checkExist = setInterval(function() {
   if ($('#picContainer').length) {
      clearInterval(checkExist);
      getImageDimensions( imageMapping[letter],
        function(width, height) {
          setImageDimensions([width, height])
        }
      );

      $('#picContainer').removeClass('d-none');
    }
  }, 100); // check every 100ms
}
jQuery(function() {
	$('#game35reveal').on('click', ".imgAll", function() {
    console.log('clicked')
	  changeGamePicture(this.textContent)
	})


	$("#game35reveal").on('click', ".picCorner", function() {
		$("input").val("");
		$("#choiceCont").css("opacity","1");
		$("#click").css("opacity","0");
		if(ptStep == 1) {
			if($(this).css("opacity") == 0) {
				ptStep = 1;
			} else if($(this).css("opacity") == 1) {
				$("#choiceTitle").css("opacity", "1");
				$("#input").css("opacity","1");
				$("#choiceSubmit").text(I18n.t('game_questions.reveal_game.click_here_to_choose_square'));
				$("#choiceSubmit").css("pointer-events", "auto");
				$("#choiceSubmit").css("box-shadow", "3px 3px 3px #333");
				$(this).fadeTo(1000,0);
				ptStep = 0;
			}
		}
	});

	$("#game35reveal").on('click', "#choiceSubmit", function() {
		var newGuess = $("#input").serialize().replace("input=",'').replace(/%20/g, " ");
		$(this).css("pointer-events", "none");
		$(this).css("box-shadow", "none");
		$("#choiceTitle").css("opacity", "0");
		$("#input").css("opacity","0");
		$("#choiceSubmit").text(I18n.t('game_questions.reveal_game.choose_next_square'));
		if(rNet == 1){
			$("#rg1").text(newGuess);
			$("#input").val("");
			$("#choiceTitle").text(I18n.t('game_questions.reveal_game.changed_thinking'));
		} else if(rNet == 2){
			$("#guess2").text(I18n.t('game_questions.reveal_game.second_thought'));
			$("#rg2").text(newGuess);
			$("#input").val("");
			$("#choiceTitle").text(I18n.t('game_questions.reveal_game.new_thoughts_about_image'));
		} else if(rNet == 3){
			$("#guess3").text(I18n.t('game_questions.reveal_game.third_thought'));
			$("#rg3").text(newGuess);
			$("#input").val("");
			$("#choiceTitle").css("opacity", "1");
			$("#choiceTitle").text(I18n.t('game_questions.reveal_game.first_last_thought'));
			$("#input").hide();
			$("#choiceSubmit").hide();
			$("#choiceNext").css("opacity", "1");
			$(".picCorner").fadeTo(1000,0);
		}
		rNet++;
		ptStep = 1;
	})
})
